/** @file Bones a transform acts on: selected, kind bone, no selected ancestor, selection order (R-E1-08). */
import type { Id } from '@pose2d/format/types';
import type { ToolContext } from '../../panels/viewport/viewportTypes';

/** Data indices; the last one carries the gizmo. */
export function topSelected(ctx: Pick<ToolContext, 'data' | 'maps'>, ids: readonly Id[]): number[] {
  const chosen = new Set(ids.flatMap((id) => { const i = ctx.maps.boneIndex.get(id); return i !== undefined && ctx.data.bones[i]?.kind === 'bone' ? [i] : []; }));
  const covered = (i: number): boolean => {
    for (let p = ctx.data.bones[i]?.parent ?? -1; p >= 0; p = ctx.data.bones[p]?.parent ?? -1) if (chosen.has(p)) return true;
    return false;
  };
  return [...chosen].filter((i) => !covered(i));
}
